/**
 * additional breakpoint names taked from
 * https://en.wikipedia.org/wiki/Display_resolution#Common_display_resolutions
 */
export const BREAKPOINTS = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    HD: 1366,
    WXGAPlus: 1440,
    HDPlus: 1600,
  },
};

export const BTN_TRANSITION_TIME = 0.25;
